const renderHeader = (setDate, setMonth, month) => {
    return (
        <div id="agendaHeader" className='w100 flex between'>
            <section onClick={() => { 
                setDate(new Date().getFullYear() -1, 12);
                setMonth(12);
            }} style={{background : month === 12 && '#215fa5' }}>
                Janvier
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 1);
                setMonth(1);
            }} style={{background : month === 1 && '#215fa5' }}>
                Février
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 2);
                setMonth(2);
            }} style={{background : month === 2 && '#215fa5' }}>
                Mars
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 3);
                setMonth(3);
            }} style={{background : month === 3 && '#215fa5' }}>
                Avril
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 4);
                setMonth(4);
            }} style={{background : month === 4 && '#215fa5' }}>
                Mai
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 5);
                setMonth(5);
            }} style={{background : month === 5 && '#215fa5' }}>
                Juin
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 6);
                setMonth(6);
            }} style={{background : month === 6 && '#215fa5' }}>
                Juillet
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 7);
                setMonth(7);
            }} style={{background : month === 7 && '#215fa5' }}>
                Août
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 8);
                setMonth(8);
            }} style={{background : month === 8 && '#215fa5' }}>
                Septembre
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 9);
                setMonth(9);
            }} style={{background : month === 9 && '#215fa5' }}>
                Octobre
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 10);
                setMonth(10);
            }} style={{background : month === 10 && '#215fa5' }}>
                Novembre
            </section>
            <section onClick={() => { 
                setDate(new Date().getFullYear(), 11);
                setMonth(11);
            }} style={{background : month === 11 && '#215fa5' }}>
                Décembre
            </section>
        </div>
    );
};
export default renderHeader